export enum EMaterialStatus {
  ACTIVE = 'ACTIVE',
  OFFLINE = 'OFFLINE',
  MAINTENANCE = 'MAINTENANCE',
  STANDBY = 'STANDBY',
  OPERATIONALONLINE = 'OPERATIONALONLINE',
}

/**
 * Device Manager Type - Determines how the material's campaigns are managed
 * MAGICINFO: Managed via Samsung MagicInfo (legacy)
 * FIREBASE: Managed via Firebase/custom app
 * LED_PANEL: Same Firebase/custom app device, HDMI output cropped for a Novastar-driven LED panel
 */
export enum EDeviceManagerType {
  MAGICINFO = 'MAGICINFO',
  FIREBASE = 'FIREBASE',
  LED_PANEL = 'LED_PANEL',
}

/**
 * Output resolution of the TV box's HDMI signal for LED_PANEL materials.
 * The panel rectangle (width/height/offset) is positioned inside a canvas of this size.
 */
export enum ELedPanelOutputResolution {
  HD_1280x720 = '1280x720',
  FULL_HD_1920x1080 = '1920x1080',
}

/**
 * Physical hardware driving a LED_PANEL material.
 * TVBOX_HDMI: TV box HDMI output -> TB20 Plus -> MRV416 -> panel (stretched video, mp4 variant)
 * ESP32_HUB75: ESP32 drives the panel pixels directly, no HDMI - reads a raw RGB565 .bin from SD
 */
export enum ELedPanelTarget {
  TVBOX_HDMI = 'TVBOX_HDMI',
  ESP32_HUB75 = 'ESP32_HUB75',
}

export enum EMaterialAlertType {
  HIGH_OSCILLATION = 'HIGH_OSCILLATION',
  MEDIUM_OSCILLATION = 'MEDIUM_OSCILLATION',
  PRE_OFFLINE = 'PRE_OFFLINE',
  HEALTHCHECK_ISSUE = 'HEALTHCHECK_ISSUE',
}

export enum EComplianceStatus {
  COMPLIANT = 'COMPLIANT',
  ALERT = 'ALERT',
  OFFLINE = 'OFFLINE',
  UNAVAILABLE = 'UNAVAILABLE',
}
